<template>
    <svg data-icon-name="service-app" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.526 33"><path d="M16.645,33H1.882A2.048,2.048,0,0,1,0,30.974V1.882A1.916,1.916,0,0,1,1.882,0H16.645a1.916,1.916,0,0,1,1.882,1.882V30.974A1.864,1.864,0,0,1,16.645,33ZM1.882,1.158a.684.684,0,0,0-.724.724V30.974a.811.811,0,0,0,.724.868H16.645c.434,0,.724-.289.724-.868V1.882a.684.684,0,0,0-.724-.724H1.882Z" fill="#000a12"/><path d="M7.071,18.3a2.171,2.171,0,1,0,0,4.342,2.171,2.171,0,1,0,0-4.342Zm0,3.329a1.142,1.142,0,0,1-1.158-1.158,1.065,1.065,0,0,1,1.158-1.158,1.065,1.065,0,0,1,1.158,1.158A1.142,1.142,0,0,1,7.071,21.629Z" transform="translate(2.192 8.187)" fill="#000a12"/></svg>
</template>

<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({});
</script>
